import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/system';
import colors from '../../assets/colors';

const StyledFormControl = styled(FormControl)({
  '& label.Mui-focused': {
    color: colors.agroweGreen,
  },
  '& .MuiInput-underline': {
    borderBottomColor: colors.agroweGreen,
  },
  '& .MuiInput-underline:hover:before': {
    borderBottomColor: 'rgba(17, 131, 82, 0.5)',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: colors.agroweGreen,
  },
});

const DataGridFormControl = (props) => (
  <StyledFormControl variant="outlined" {...props} />
);
export default DataGridFormControl;
